export { default } from './Settings.wrapper';
